import React from 'react';
import Olho from '../../assets/imgs/olho.png';

function ServicesSection() {
  return (
    <section id="servicos" className="py-5 bg-light">
      <div className="container text-center"> {/* Adicionado text-center para centralizar */}
        <img
          src={Olho}
          style={{ width: "60px", display: "block", margin: "auto" }}
          alt="Ícone Olho"
        />
        <h2 className="text-center mb-1 mt-3">Serviços Visão Positiva</h2>
        <br />
        <p className="lead text-center mb-5">
          Na Visão Positiva, combinamos expertise e tecnologia de ponta para realizar análises minuciosas em veículos, com o objetivo de identificar sinais de adulteração ou fraude e avaliar reparos estruturais significativos com total transparência e confiabilidade. Realizamos inspeções detalhadas que detectam eventuais irregularidades, promovendo a segurança dos ocupantes e a integridade do veículo, além de prevenir fraudes e evitar futuros gastos com reparos mais complexos. Essa avaliação completa oferece confiança tanto para compradores quanto para vendedores, garantindo uma negociação justa e protegendo o seu investimento.
        </p>
      </div>
    
    </section>
  );
}

export default ServicesSection;
